import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createUnitTicket, type CreateTicketInput, type Ticket } from '../api/bol'
import { unitDetailsQueryKey } from './useUnitDetails'

export function useCreateTicket() {
    const queryClient = useQueryClient()

    return useMutation<Ticket, unknown, CreateTicketInput>({
        mutationFn: createUnitTicket,
        onSuccess: (_ticket, input) => {
            // The new ticket is created at access type 183 (unit-published), which is
            // exactly what ticket_summary_by_unit filters on, so refetching the unit
            // details is enough to make it appear in the Tickets section.
            void queryClient.invalidateQueries({
                queryKey: unitDetailsQueryKey(input.unitId, input.blockId),
            })
        },
    })
}
